import { formatDate } from "../../i18n/dateLocale";
import React from "react";
import { useTranslation } from "react-i18next";

const SupportTable = (props) => {
    const { t } = useTranslation();
    return (
        <>
            <div className="table-wrapper px-3 pt-3">
                <p className="table-type">{t("admin.support.table.supportList")}</p>
                <div className="table-wrapper-scroll-y table-scrollbar">
                    <div className="table-own table-responsive">
                        <table className="table table-striped table-hover table-admin">
                            <thead className="table-head">
                                <tr>
                                    {/* <th
                                        className={`sort-header cursor ${props?.sortObj?.sortVal === "title" ? "active" : ""
                                            } ${props?.sortObj?.sortType ? "aesc" : "desc"}`}
                                        onClick={() => props.arraySorting("title")}
                                    >
                                        <span>Title</span>
                                        {props?.sortObj?.sortType === "aesc" && (
                                            <i className="fas fa-caret-down"></i>
                                        )}
                                        {props?.sortObj?.sortType === "desc" && (
                                            <i className="fas fa-caret-up"></i>
                                        )}
                                    </th>
                                    <th
                                        className={`sort-header cursor ${props?.sortObj?.sortVal === "email"
                                            ? "active"
                                            : ""
                                            } ${props?.sortObj?.sortType ? "aesc" : "desc"}`}
                                        onClick={() => props.arraySorting("email")}
                                    >
                                        <span>Email</span>
                                        {props?.sortObj?.sortType === "aesc" && (
                                            <i className="fas fa-caret-down"></i>
                                        )}
                                        {props?.sortObj?.sortType === "desc" && (
                                            <i className="fas fa-caret-up"></i>
                                        )}
                                    </th>
                                    <th className={`sort-header cursor ${props?.sortObj?.sortVal === "mobile"
                                        ? "active"
                                        : ""
                                        } ${props?.sortObj?.sortType ? "aesc" : "desc"}`}
                                        onClick={() => props.arraySorting("mobile")}>
                                        <span>Mobile</span>
                                        {props?.sortObj?.sortType === "aesc" && (
                                            <i className="fas fa-caret-down"></i>
                                        )}
                                        {props?.sortObj?.sortType === "desc" && (
                                            <i className="fas fa-caret-up"></i>
                                        )}
                                    </th> */}
                                    {/* <th className={`sort-header cursor ${props?.sortObj?.sortVal === "message"
                                        ? "active"
                                        : ""
                                        } ${props?.sortObj?.sortType ? "aesc" : "desc"}`}
                                        onClick={() => props.arraySorting("message")}>
                                        <span>Message</span>
                                        {props?.sortObj?.sortType === "aesc" && (
                                            <i className="fas fa-caret-down"></i>
                                        )}
                                        {props?.sortObj?.sortType === "desc" && (
                                            <i className="fas fa-caret-up"></i>
                                        )}
                                    </th> */}
                                    {/* <th className="sort-header ">
                                        <span>View</span>
                                    </th> */}
                                    <th>{t("common.title")}</th>
                                    <th>{t("common.email")}</th>
                                    <th>{t("common.mobile")}</th>
                                    <th className="text-center">{t("admin.support.table.dateOfRequest")}</th>
                                    {props?.type!=='open' &&
                                        <th className="text-center">{t("admin.support.table.dateOfClosure")}</th>
                                    }
                                    <th className="text-center">
                                        <span>{t("common.action")}</span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="table-body">
                                {props.dataList.map((data) => {
                                    return (
                                        (
                                            <tr key={data?.supportId}>
                                                <td>{data?.title}</td>
                                                <td>{data?.email}</td>
                                                <td>
                                                    {data?.mobile}
                                                </td>
                                                {/* <td>
                                                    {data?.message}
                                                </td> */}
                                                {/* <td
                                                    className="cursor"
                                                    onClick={() => {
                                                        props.viewVideo(data);
                                                    }}
                                                >
                                                    <i className="far fa-eye primary-color"></i>
                                                </td> */}
                                                <td className="text-center">
                                                {data?.created
                                                ? formatDate(new Date(data?.created))
                                                : "NA"}
                                                </td>
                                                {props?.type!=='open' &&
                                                    <td className="text-center">
                                                    {data?.closedDate
                                                    ? formatDate(new Date(data?.closedDate))
                                                    : "NA"}
                                                    </td>
                                                }
                                                <td className="text-center">

                                                    <span
                                                        onClick={() => props?.openModalFunc(data)}
                                                        className="btn btn-own-admin primary-btn btn-sm-own table-action"
                                                    >
                                                        {t("common.view")}
                                                    </span> {props?.type==='open' &&
                                                    <>
                      |{" "}
                      <span
                        className="mx-1 btn btn-own-admin primary-btn btn-sm-own table-action"
                        onClick={() => props.openModalCloseFunc(data)}
                      >
                        {t("common.close")}
                      </span>
                      </>}
                                                </td>
                                            </tr>
                                        )
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SupportTable;
